export default "https://cdn-static.gokick.com/assets/28dce4dd80241a45018c00057f67470c3fae89ba/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";